import { __extends, __makeTemplateObject } from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import exenv from 'exenv';
import * as colors from '../colors';
import { CHANNEL, DEFAULT_THEME_MODE } from '../constants';
// For forward-compat until everything is upgraded.
import Theme from './Theme';
function getStylesheetResetCSS(state) {
    var backgroundColor = colors.background(state);
    return "\n    body { background: " + backgroundColor + "; }\n  ";
}
function buildThemeState(mode) {
    var _a;
    return { theme: (_a = {}, _a[CHANNEL] = { mode: mode }, _a) };
}
var LegacyReset = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"], ["\n  background-color: ", ";\n  color: ", ";\n\n  a {\n    color: ", ";\n  }\n  a:hover {\n    color: ", ";\n  }\n  a:active {\n    color: ", ";\n  }\n  a:focus {\n    outline-color: ", ";\n  }\n  h1 {\n    color: ", ";\n  }\n  h2 {\n    color: ", ";\n  }\n  h3 {\n    color: ", ";\n  }\n  h4 {\n    color: ", ";\n  }\n  h5 {\n    color: ", ";\n  }\n  h6 {\n    color: ", ";\n  }\n  small {\n    color: ", ";\n  }\n"])), colors.background, colors.text, colors.link, colors.linkHover, colors.linkActive, colors.linkOutline, colors.heading, colors.heading, colors.heading, colors.heading, colors.heading, colors.subtleHeading, colors.subtleText);
var AtlaskitThemeProvider = /** @class */ (function (_super) {
    __extends(AtlaskitThemeProvider, _super);
    function AtlaskitThemeProvider(props) {
        var _this = _super.call(this, props) || this;
        /**
         * This function never changes its reference because it accesses
         * `this` in the function call - thereby sidestepping the need for
         * creating a new reference everytime theme state changes.
         * NOTE: When moving to hooks watch out for this regressing.
         */
        _this.getThemeMode = function () { return ({ mode: _this.state.theme[CHANNEL].mode }); };
        _this.state = buildThemeState(props.mode);
        return _this;
    }
    AtlaskitThemeProvider.prototype.getChildContext = function () {
        return { hasAtlaskitThemeProvider: true };
    };
    AtlaskitThemeProvider.prototype.UNSAFE_componentWillMount = function () {
        if (!this.context.hasAtlaskitThemeProvider && exenv.canUseDOM) {
            var css = getStylesheetResetCSS(this.state);
            this.stylesheet = document.createElement('style');
            this.stylesheet.type = 'text/css';
            this.stylesheet.innerHTML = css;
            if (document && document.head) {
                document.head.appendChild(this.stylesheet);
            }
        }
    };
    AtlaskitThemeProvider.prototype.UNSAFE_componentWillReceiveProps = function (newProps) {
        if (newProps.mode !== this.props.mode) {
            var newThemeState = buildThemeState(newProps.mode);
            if (this.stylesheet) {
                var css = getStylesheetResetCSS(newThemeState);
                this.stylesheet.innerHTML = css;
            }
            this.setState(newThemeState);
        }
    };
    AtlaskitThemeProvider.prototype.componentWillUnmount = function () {
        if (this.stylesheet && document && document.head) {
            document.head.removeChild(this.stylesheet);
            delete this.stylesheet;
        }
    };
    AtlaskitThemeProvider.prototype.render = function () {
        var children = this.props.children;
        var theme = this.state.theme;
        return (
        /* Wrapping the new provider around the old one provides forward
        compatibility when using the old provider for styled components. This
        allows us to use components converted to use the new API with consumers
        using the old provider along side components that may still be using the
        old theming API. */
        React.createElement(Theme.Provider, { value: this.getThemeMode },
            React.createElement(ThemeProvider, { theme: theme },
                React.createElement(LegacyReset, null, children))));
    };
    AtlaskitThemeProvider.defaultProps = {
        mode: DEFAULT_THEME_MODE,
    };
    AtlaskitThemeProvider.childContextTypes = {
        hasAtlaskitThemeProvider: PropTypes.bool,
    };
    AtlaskitThemeProvider.contextTypes = {
        hasAtlaskitThemeProvider: PropTypes.bool,
    };
    return AtlaskitThemeProvider;
}(Component));
export default AtlaskitThemeProvider;
var templateObject_1;
//# sourceMappingURL=AtlaskitThemeProvider.js.map